<div class="loader-wrapper">
  <img class="page-loader" src="../../../../assets/loaders/ellipsis.svg" />
</div>
